var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToken(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "token") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u56FE",
    transform: "translate(-191.000000, -1462.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "token",
    transform: "translate(191.000000, 1462.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,1 C11.8659932,1 15,4.13400675 15,8 C14.9961123,11.8643818 11.8643818,14.9961123 8,15 C4.13400675,15 1,11.8659932 1,8 C1,4.13400675 4.13400675,1 8,1 Z M8,2.2025189 C5.65339065,2.2025189 3.53791004,3.61627131 2.64023131,5.78439223 C1.74255258,7.95251316 2.23950884,10.4479064 3.89931665,12.1067052 C5.55912446,13.765504 8.05481942,14.2609428 10.2223941,13.3619458 C12.3899687,12.4629488 13.8024341,10.3466089 13.8010086,8 C13.7971179,4.79837538 11.2016264,2.20446163 8,2.2025189 Z M8.94156171,4.58639798 L11.4312342,7.07607054 C11.9489365,7.59840954 11.9489365,8.44038139 11.4312342,8.9627204 L8.94156171,11.4312342 C8.69243116,11.6820021 8.35348339,11.822913 8,11.8226756 C7.64636004,11.8237012 7.30712049,11.682669 7.05843829,11.4312342 L4.56876575,8.9627204 C4.31831904,8.71267388 4.17758585,8.37329774 4.17758585,8.01939547 C4.17758585,7.6654932 4.31831904,7.32611705 4.56876575,7.07607054 L7.05843829,4.58639798 C7.57877432,4.0671751 8.42122568,4.0671751 8.94156171,4.58639798 Z M8,5.37984886 C7.96413075,5.37831586 7.92937166,5.39247698 7.90478589,5.4186398 L5.41511336,7.90478589 C5.38970102,7.92995303 5.37540373,7.96423449 5.37540373,8 C5.37540373,8.03576551 5.38970102,8.07004697 5.41511336,8.09521411 L7.90478589,10.5848866 C7.92995303,10.610299 7.96423449,10.6245963 8,10.6245963 C8.03576551,10.6245963 8.07004697,10.610299 8.09521411,10.5848866 L10.5813602,8.09521411 C10.6067725,8.07004697 10.6210698,8.03576551 10.6210698,8 C10.6210698,7.96423449 10.6067725,7.92995303 10.5813602,7.90478589 L8.11284635,5.43627205 C8.08790022,5.39878129 8.04496028,5.37731132 8,5.37984886 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    fill: "#575C62",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToken);
export default __webpack_public_path__ + "static/media/token.dd83fe997fc509afeb44a08889a69e05.svg";
export { ForwardRef as ReactComponent };